import React from 'react';
import {func, bool, string} from 'prop-types';
import styles from './mobileNavSearchInput.scss';
import SearchIcon from 'dibs-vg/dist/react/magnifying-glass';
import CloseIcon from 'dibs-vg/dist/react/close';
import copy from './mobileNavSearchInputCopy.json';

export default function MobileNavSearchInput(props) {
    return (
        <div className={styles.container}>
            <div className={styles.iconWrapper} onClick={props.onIconClick}>
                <SearchIcon className={styles.searchIcon} />
            </div>
            <form onSubmit={e => props.onSubmit(e)} className={styles.form} action="/search/">
                <input
                    autoCorrect="off"
                    autoCapitalize="off"
                    autoComplete="off"
                    spellCheck="false"
                    name="q"
                    onFocus={props.onFocus}
                    onInput={props.onInput}
                    type="search"
                    placeholder={copy.placeholder}
                    value={props.value}
                    className={styles.input}
                />
            </form>
            {props.showClose && (
                <div className={styles.iconWrapper} onClick={props.onCloseClick}>
                    <CloseIcon className={styles.closeIcon} />
                </div>
            )}
        </div>
    );
}

MobileNavSearchInput.propTypes = {
    onInput: func.isRequired,
    onFocus: func.isRequired,
    onIconClick: func.isRequired,
    onCloseClick: func.isRequired,
    onSubmit: func.isRequired,
    showClose: bool,
    value: string
};

MobileNavSearchInput.defaultProps = {
    onInput: () => {},
    onIconClick: () => {}
};



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavSearchInput/MobileNavSearchInput.jsx